// legacy IE function
// expression( <any-value> )
module.exports = function () {
  return this.createSingleNodeList(this.Raw(this.scanner.tokenIndex, null, false));
};